import { IProduct, IProductRes } from '@/interfaces/product';
import * as baseAdapter from './baseAdapter';

export const searchProducts = async (req: any) => {
  const ret = await baseAdapter.post<IProductRes>('/v1/product/gets', req);
  return ret?.data;
};

export const addProduct = async (data: Partial<IProduct>) => {
  const ret = await baseAdapter.post<any>('/v1/product/add', data);
  return ret?.data;
};

export const updateProduct = async (data: Partial<IProduct>) => {
  const ret = await baseAdapter.put('/v1/product/update', data);
  return ret?.data;
};

export const matchProduct = async (data: Partial<IProduct>) => {
  const ret = await baseAdapter.put('/v1/product/match', data);
  return ret?.data;
};
